module.exports = __webpack_public_path__ + "img/ic-menu.d7c42181.svg";